import React from "react";
import { Box, useTheme } from "@mui/material";
import { GripVertical, Trash2 } from "lucide-react";
import { TFunction } from "i18next";
import ListItemCardCst from "@components/ListItemCardCst";
import { mapEntityToCard } from "@pages/Contents/V2/Corporate/Catalog/mapEntityToCard";
import { SelectedLOItem } from "@pages/Contents/V2/Corporate/Catalog/types";

interface SelectedLOListProps {
  items: SelectedLOItem[];
  tCatalog: TFunction;
  removeLabel: string;
  onRemove: (id: number) => void;
  onDetails: (item: SelectedLOItem) => void;
}

const SelectedLOList: React.FC<SelectedLOListProps> = ({
  items,
  tCatalog,
  removeLabel,
  onRemove,
  onDetails,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {items.map((it) => {
        const cardProps = mapEntityToCard(it.entity, it.kind, {
          t: tCatalog,
          onDetails: () => onDetails(it),
          omitMetrics: ["initiatives"],
        });
        return (
          <Box
            key={`${it.kind}-${it.id}`}
            sx={{ display: "flex", alignItems: "stretch", gap: 1 }}
          >
            <Box
              aria-hidden
              sx={{
                display: "flex",
                alignItems: "center",
                paddingX: 0.5,
                color: theme.palette.text.tertiary,
                cursor: "grab",
                userSelect: "none",
                opacity: 0.5,
              }}
            >
              <GripVertical size={18} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <ListItemCardCst
                {...cardProps}
                actions={[
                  // ...(cardProps.actions || []),
                  {
                    label: removeLabel,
                    icon: <Trash2 size={18} />,
                    iconOnly: true,
                    disabled: !!it.locked,
                    onClick: () => {
                      if (it.locked) return;
                      onRemove(it.id);
                    },
                  },
                ]}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default SelectedLOList;
